import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { RatingLevel, RatingTagProps } from "./types";

export const RatingTag = ({
  rating,
  className = "",
  origin,
}: RatingTagProps) => {
  // 获取等级字母（A+、A- 都归为 A）
  const getLevel = (rating: string): RatingLevel => {
    return rating?.charAt(0) as RatingLevel;
  };

  const shouldShowLock =
    origin && Object.keys(origin).length === 1 && !!origin?.final;

  // 根据等级获取颜色样式
  const getRatingStyles = (level: RatingLevel) => {
    const styleMap = {
      A: "bg-background_accent1_overlay40 text-content_primary",
      B: "bg-background_brand_overlay40 text-content_primary",
      C: "bg-background_brand_overlay20 text-content_primary",
      D: "bg-background_accent2_overlay40 text-content_primary",
    };
    return styleMap[level];
  };

  const level = getLevel(rating);
  const styles = getRatingStyles(level);

  return (
    <div
      className={cn(
        `
        inline-flex
        items-center
        justify-center
        w-[38px]
        h-[20px]
        rounded-[4px]
        body_bold_m
        ${className}
      `,
        {
          [styles]: !shouldShowLock,
        },
      )}
    >
      {shouldShowLock ? (
        <div className="relative flex items-center justify-center rounded-[4px] w-[38px] h-[20px]">
          {/* 背景层：只模糊背景 */}
          <div className="absolute inset-0 rounded-[4px] bg-background_white_overlay5 blur-[2px]"></div>
          {/* 内容层：不受模糊影响 */}
          <div className="relative z-10">
            <Icon name="lock" size={12} className="text-content_secondary" />
          </div>
        </div>
      ) : (
        rating
      )}
    </div>
  );
};
